import { useState } from "react";
import VideoPopup from "./VideoPopup";

const OttCard = ({ currentCardItem }: any) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const handleOpenPopup = (currentSrc: any) => {
    setCurrentItem(currentSrc);
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setCurrentItem(null);
  };

  return (
    <>
      <div className="col">
        <div
          className="courses__item shine__animate-item"
          style={{ padding: "25px 25px 10px" }}
        >
          <div
            onClick={() => {
              handleOpenPopup(currentCardItem?.ottMeta?.mescOttUrl);
            }}
            style={{ position: "relative", cursor: "pointer" }}
            className="courses__item-thumb"
          >
            <img
              src={
                currentCardItem?.ottMeta?.mescOttThumbnail ||
                "/assets/img/cw/1.png"
              }
              alt="img"
            />
            {/* <div className="video-length">2:00</div> */}
          </div>
          <div className="courses__item-content">
            <h5 className="title text-truncate">{currentCardItem?.title}</h5>
          </div>
        </div>
      </div>
      {isPopupOpen && (
        <VideoPopup currentItemSrc={currentItem} onClose={handleClosePopup} />
      )}
    </>
  );
};

export default OttCard;
